import useComputed from '@/hooks/use-computed'
import api from '@/services/api/personas.js'
import { immerable } from "immer"
import { useState } from 'react'

class Persona {

	[immerable] = true

	constructor(params) {
		this.id = params.id
		this.name = params.name
		this.image = params.image
		this.description = params.description
		this.keyvaluedrivers = params.keyvaluedrivers
		this.contributes = params.contributes
		this.consumes = params.consumes
		this.organizationPersonaId = params.OrganizationPersonaId
		this.status = params.status
		this.is_etr_issuer = params.is_etr_issuer
		this.$selected = false
	}
}

const usePersona = () => {

	const [items, setItems] = useComputed([])

	const [currentItem ,setCurrentItem] = useState({})
	const [error, setError] = useState()
	const [loading, setLoading] = useState(false)

	async function fetch(parameter) {
		const params = parameter ? parameter : "";

		setLoading(true)

		const [error, data] = await api.index({
			params
		})

		setLoading(false)

		if (error) {
			return setError(error)
		}

		if (!Array.isArray(data.items)) {
			return setError('Persona is not an array')
		}

		const formattedData = data.items.map(entry => serialize(entry))
		const newItems = formattedData.map(params => new Persona(params))
		return setItems(newItems)
	}

	async function find(parameter) {
		setLoading(true)

		const params = parameter ? parameter : "";

		const [error, data] = await api.index({
			params
		})
		setLoading(false)

		if (error) {
			return setError(error)
		}

		if (!Array.isArray(data.items)) {
			return setError('Persona is not an array')
		}

		const serializedData = data.items.map(entry => serialize(entry))
		const newItems = serializedData.map(params => new Persona(params))
		return newItems
	}

	async function findAndSetCurrentPersona(params) {
		setLoading(true)

		// const params = parameter ? parameter : "";

		const [error, data] = await api.findUseCasePersona(params.personaId, params.useCaseId)

		setLoading(false)

		if (error) {
			return setError(error)
		}

		if (!data) {
			return setError('Persona not found')
		}

		const serializedData = serialize(data);
		const newItem = new Persona(serializedData)

		// view(parameter)
		setCurrentItem(newItem);
		// return newCurrentItem
	}


	function serialize(entry) {
		return {
			id: entry.id,
			name: entry.name,
			image: entry.image,
			description: entry.description,
			keyvaluedrivers: entry.keyvaluedrivers,
			contributes: entry.contributes,
			consumes: entry.consumes,
			OrganizationPersonaId: entry.OrganizationPersonaId,
			status: entry.enrollstatus,
			is_etr_issuer: entry.is_etr_issuer
		}
	}

	function view(id) {
		const newCurrentItem = items.find(item => item.id === id)
		setCurrentItem(newCurrentItem)
	}

	return {
		error,
		fetch,
		items,
		currentItem,
		setCurrentItem,
		loading,
		setItems,
		view,
		find,
		findAndSetCurrentPersona
	}

}

export default usePersona;
